import { connect } from 'react-redux';

import withOverlayControls from 'eventbrite_design_system/structure/hoc/withOverlayControls';

import Header from '../components/Header';
import { clickCTASeasonal } from '../redux/content/actions';

const _mapStateToProps = ({ header, app }) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(Header),
);
